module.exports = __webpack_public_path__ + "img/HEART SHADES LIME.fa80462.svg";